import React, { FC, useState } from "react";
import {
  IonContent,
  IonPage,
  IonIcon,
  IonList,
  IonSplitPane,
  IonButton,
  IonText,
} from '@ionic/react';
import { LayoutProps } from './Layout.model';
import {
  showSettingsPayment,
  showSettingsProfile,
  showSettingsUpload,
  showSignInState,
  userState,
  viewState
} from '../../atoms';
import { useRecoilValue, useSetRecoilState } from "recoil";
import cn from 'classnames';
import { signOut } from "firebase/auth";
import { whichAuth as getAuth } from "../../getAuth";
import { Menu } from "../index";
import { signupInProgress } from "../../utils/signupInProgress";
import { viewDashboard, viewSettings } from "../../constants/global";
import SignOut from '../../assets/Menu/sign-out.svg';
import LogoIcon from '../../assets/logo-default.svg';
 import { menuOutline } from 'ionicons/icons';
import UploadIcon from "../../assets/upload-white.svg";
import './Layout.css'

const Layout: FC<LayoutProps> = ({ children }) => {

  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const setUser = useSetRecoilState(userState);
  const setShowSignIn = useSetRecoilState(showSignInState);
  const user = useRecoilValue(userState);
  const setView = useSetRecoilState(viewState)
  const setProfile = useSetRecoilState(showSettingsProfile)
  const setPayment = useSetRecoilState(showSettingsPayment)
  const setUpload = useSetRecoilState(showSettingsUpload)

  const handleOut = () => signOut(getAuth()).finally(() => {setUser(null); setShowSignIn(true)})

  return (
    <IonContent>
      <IonSplitPane contentId="main">
        {user && (
          <>
            <div id="menu" className={cn('left-layout', { 'active': openMenu })}>
              <div className="layout-wrapper">
                <div>
                  <IonIcon
                    src={LogoIcon}
                    className={cn('logo-menu', { 'little-height': window?.outerHeight < 720 })}
                    onClick={() => {
                      setView(viewDashboard)
                      setOpenMenu(false)
                    }}
                  />
                  <IonList className="menu-list-layout">
                    <Menu onOpen={() => setOpenMenu(false)} />
                    <IonButton
                      onClick={() => {
                        setView(viewSettings)
                        setProfile(false)
                        setPayment(false)
                        setUpload(true)
                        setOpenMenu(false)
                      }}
                      disabled={signupInProgress(user)}
                      className="menu-upload-button"
                    >
                      <IonIcon src={UploadIcon} className="menu-upload-icon" />
                      Add a Bill
                    </IonButton>
                  </IonList>
                </div>
                <IonButton
                  onClick={handleOut}
                  className="menu-item-layout menu-item-layout-bottom ion-text-left"
                >
                  <IonIcon src={SignOut} className="icon-layout-bottom" />
                  <IonText className="label-layout">
                    Log out
                  </IonText>
                </IonButton>
              </div>
              <IonIcon
                icon={menuOutline}
                className={cn('arrow-layout', { 'active': openMenu })}
                onClick={() => setOpenMenu(!openMenu)}
              />
            </div>
          </>
        )}
        <IonPage id="main" onClick={() => setOpenMenu(false)}>
          {children}
        </IonPage>
      </IonSplitPane>
    </IonContent>
  )
}

export default Layout
